import React, { useEffect, useState } from "react";
import { Spin, Table, Tag } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link, useHistory } from "react-router-dom";
import { CiViewList } from "react-icons/ci";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import backdrop from "@mui/material/Backdrop";
import { Spinner } from "react-bootstrap";
import {
  cancelAdminOrder,
  getOrderCoinDcx,
  getTradingPair,
  reconcileOrders,
} from "../../../service/api";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import moment from "moment";
import { toast } from "react-toastify";
import { formatLargeNumber } from "../../../config/helper";
import { triggerDownload } from "../../../config/downloadUtils";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Select from "react-select";
import { sanitizeInput } from "../../../config/validation";

const EXCHANGE_LABELS = { coindcx: "CoinDCX", kucoin: "KuCoin", custom: "Custom Token" };
const EXCHANGE_COLORS = { coindcx: "blue", kucoin: "purple", custom: "orange" };

const formatDateTime = (val) =>
  val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";

const ALL_COLUMNS = [
  {
    key: "exchange",
    title: "Exchange",
    defaultVisible: false,
    render: (r) => {
      const val = String(r?.exchange || "coindcx").toLowerCase();
      return <Tag color={EXCHANGE_COLORS[val] || "default"}>{EXCHANGE_LABELS[val] || val}</Tag>;
    },
  },
  {
    key: "user",
    title: "User",
    defaultVisible: true,
    render: (r) => `${r?.user?.firstName ?? ""} ${r?.user?.lastName ?? ""}`.trim() || "-",
  },
  {
    key: "email",
    title: "Email",
    defaultVisible: false,
    render: (r) => r?.user?.email || "-",
  },
  {
    key: "pair",
    title: "Pair",
    defaultVisible: false,
    render: (r) =>
      r?.fromCoin?.symbol && r?.toCoin?.symbol
        ? `${r.fromCoin.symbol}/${r.toCoin.symbol}`
        : "-",
  },
  {
    key: "amount",
    title: "Amount",
    defaultVisible: true,
    render: (r) =>
      r?.amount !== undefined && r?.amount !== null
        ? `${formatLargeNumber(r.amount)} ${r?.toCoin?.symbol || ""}`
        : "-",
  },
  {
    key: "price",
    title: "Price",
    defaultVisible: true,
    render: (r) =>
      r?.price !== undefined && r?.price !== null
        ? `${r.price} ${r?.toCoin?.symbol || ""}`
        : "-",
  },
  {
    key: "quantity",
    title: "Quantity",
    defaultVisible: true,
    render: (r) =>
      r?.quantity !== undefined && r?.quantity !== null
        ? `${Number(r.quantity).toPrecision(5)} ${r?.fromCoin?.symbol || ""}`
        : "-",
  },
  {
    key: "tradeType",
    title: "Type",
    defaultVisible: true,
    render: (r) => r?.type || "-",
  },
  {
    key: "orderType",
    title: "Side",
    defaultVisible: true,
    render: (r) => r?.orderType || "-",
  },
  {
    key: "orderStatus",
    title: "Order Status",
    defaultVisible: true,
    render: (r) => r?.orderId?.orderStatus || r?.orderStatus || "-",
  },
  {
    key: "tds",
    title: "TDS",
    defaultVisible: false,
    render: (r) =>
      r?.tds !== undefined && r?.tds !== null ? r.tds : "-",
  },
  {
    key: "fee",
    title: "Fee",
    defaultVisible: false,
    render: (r) =>
      r?.fee !== undefined && r?.fee !== null
        ? `${Number(r.fee).toPrecision(5)} ${r?.toCoin?.symbol || ""}`
        : "-",
  },
  {
    key: "date",
    title: "Date",
    defaultVisible: true,
    render: (r) => formatDateTime(r?.createdAt),
  },
];

const exchangeOptions = [
  { label: "CoinDCX",      value: "coindcx" },
  { label: "KuCoin",       value: "kucoin"  },
  { label: "Custom Token", value: "custom"  },
];

const sideOptions = [
  { label: "Buy", value: "BUY" },
  { label: "Sell", value: "SELL" },
];

const tradeTypeOptions = [
  { label: "Market", value: "MARKET" },
  { label: "Limit", value: "LIMIT" },
];

const orderStatusOptions = [
  { label: "Open", value: "OPEN" },
  { label: "Filled", value: "FILLED" },
  { label: "Cancelled", value: "CANCELLED" },
  { label: "Partially Filled", value: "PARTIALLY_FILLED" },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "40px",
    width: "200px",
    minWidth: "120px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    padding: "0px 4px",
    backgroundColor: "#fff",
  }),
  dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
  indicatorSeparator: () => ({ display: "none" }),
};

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 320,
  background: "white",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const CANCELLABLE = ["OPEN", "PARTIALLY_FILLED"];

const Order = () => {
  const history = useHistory();
  const [orderList, setOrderList] = useState([]);
  const [pairs, setPairs] = useState([]);
  const [pair, setPair] = useState();
  const [exchange, setExchange] = useState();
  const [orderType, setOrderType] = useState();
  const [tradeType, setTradeType] = useState();
  const [orderStatus, setOrderStatus] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOrderId, setFilterOrderId] = useState("");
  const [filterUserId, setFilterUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [reconcileLoading, setReconcileLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  // Cancel modal
  const [cancelTarget, setCancelTarget] = useState(null);
  const [cancelLoading, setCancelLoading] = useState(false);

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "order-list",
    allColumns: ALL_COLUMNS,
  });

  const getOrderList = () => {
    let body = {
      page,
      sizePerPage: pageSize,
      pagination: true,
    };
    if (exchange) body.exchange = exchange?.value;
    if (pair) body.pairId = pair?.value;
    if (orderType) body.orderType = orderType?.value;
    if (tradeType) body.tradeType = tradeType?.value;
    if (orderStatus) body.orderStatus = orderStatus?.value;
    if (searchTerm) body.search = searchTerm;
    if (filterOrderId) body.orderId = filterOrderId;
    if (filterUserId) body.filterUserId = filterUserId;
    if (startDate && endDate) {
      body.startDate = startDate;
      body.endDate = endDate;
    }
    setLoading(true);
    getOrderCoinDcx(body)
      .then((res) => {
        if (res?.status) setOrderList(res?.data);
      })
      .finally(() => setLoading(false));
  };

  const handleDownload = (format) => {
    const body = { pagination: false };
    if (exchange) body.exchange = exchange?.value;
    if (pair) body.pairId = pair?.value;
    if (orderType) body.orderType = orderType?.value;
    if (tradeType) body.tradeType = tradeType?.value;
    if (orderStatus) body.orderStatus = orderStatus?.value;
    if (searchTerm) body.search = searchTerm;
    if (filterOrderId) body.orderId = filterOrderId;
    if (filterUserId) body.filterUserId = filterUserId;
    if (startDate && endDate) {
      body.startDate = startDate;
      body.endDate = endDate;
    }
    setDownloadLoading(true);
    getOrderCoinDcx(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "spot-orders");
      })
      .finally(() => setDownloadLoading(false));
  };

  const getPairList = () => {
    getTradingPair({ page: 1, sizePerPage: 10, pagination: false })
      .then((res) => {
        if (res?.status) {
          setPairs(
            res?.data?.result?.map((item) => ({
              value: item?._id,
              label: `${item?.fromCoin?.symbol}/${item?.toCoin?.symbol}`,
            }))
          );
        }
      })
      .catch(() => {});
  };

  const handleCancelConfirm = () => {
    if (!cancelTarget) return;
    setCancelLoading(true);
    cancelAdminOrder(cancelTarget._id)
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message || "Order cancelled successfully", { toastId: 'order-cancel-success' });
          setCancelTarget(null);
          getOrderList();
        } else {
          toast.error(res?.message || "Failed to cancel order", { toastId: 'order-cancel-error' });
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message || "Something went wrong", { toastId: 'order-cancel-error' });
      })
      .finally(() => setCancelLoading(false));
  };

  const handleReconcile = () => {
    setReconcileLoading(true);
    reconcileOrders()
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message || "Reconciliation complete", { toastId: 'order-reconcile-success' });
          getOrderList();
        } else {
          toast.error(res?.error || "Reconciliation failed", { toastId: 'order-reconcile-error' });
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.error || "Reconciliation failed", { toastId: 'order-reconcile-error' });
      })
      .finally(() => setReconcileLoading(false));
  };

  useEffect(() => {
    getPairList();
  }, []);

  useEffect(() => {
    getOrderList();
  }, [page, pageSize, exchange, pair, orderType, tradeType, orderStatus, searchTerm, filterOrderId, filterUserId, startDate, endDate]);

  useEffect(() => {
    setPage(1);
  }, [pageSize, exchange, pair, orderType, tradeType, orderStatus, searchTerm, filterOrderId, filterUserId, startDate, endDate]);

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => {
      const status = row?.orderId?.orderStatus || row?.orderStatus || "";
      const canCancel = CANCELLABLE.includes(status);
      return (
        <div className="text-end" style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
          <a
            onClick={() => history.push(`/admin/order-detail/${row?._id}`)}
            className="btn btn-sm bg-primary-light"
          >
            <CiViewList /> View details
          </a>
          {canCancel && (
            <a
              onClick={(e) => { e.stopPropagation(); setCancelTarget(row); }}
              className="btn btn-sm bg-danger-light"
            >
              Cancel
            </a>
          )}
        </div>
      );
    },
  };

  const columns2 = [...dynamicColumns, actionColumn];

  const handleDateRangeChange = (event, picker) => {
    setStartDate(picker.startDate.format("YYYY-MM-DD"));
    setEndDate(picker.endDate.format("YYYY-MM-DD"));
  };

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-sm-7">
                <h3 className="page-title">Orders</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Orders</li>
                </ul>
              </div>
              <div className="col-sm-5 text-end">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={handleReconcile}
                  disabled={reconcileLoading}
                >
                  {reconcileLoading ? <Spinner size="sm" /> : "Reconcile"}
                </button>
              </div>
            </div>
          </div>

          <div className="list-layout">
            <div className="list-layout__main">
              <div className="card">
                <div className="card-body">
                  <TableToolbar
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    pageSizeOptions={pageSizeOptions}
                    total={orderList?.total}
                    page={page}
                    visibleColumnKeys={visibleColumnKeys}
                    allColumns={ALL_COLUMNS}
                    toggleColumn={toggleColumn}
                    resetColumns={resetColumns}
                    onDownload={handleDownload}
                    downloadLoading={downloadLoading}
                  />
                  <div className="table-responsive">
                    {loading ? (
                      <div className="his-spin">
                        <Spin size="large" style={{ position: "relative", top: "35%" }} />
                      </div>
                    ) : (
                      <Table
                        pagination={false}
                        style={{ overflowX: "auto" }}
                        columns={columns2}
                        dataSource={orderList ? orderList?.result : []}
                        rowKey={(record) => record._id || record.id}
                      />
                    )}
                    {orderList && orderList?.total > pageSize && (
                      <CustomPagination
                        key={`pg-${pageSize}`}
                        totalTabs={orderList?.total}
                        tabsPerPage={pageSize}
                        handleChange={setPage}
                        className={`${loading ? "display-hide" : "display-flex"}`}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="list-layout__filters">
              <FilterPanel
                count={orderList?.total}
                onClear={() => {
                  setExchange(null);
                  setPair(null);
                  setOrderType(null);
                  setTradeType(null);
                  setOrderStatus(null);
                  setSearchTerm("");
                  setFilterOrderId("");
                  setFilterUserId("");
                  setStartDate();
                  setEndDate();
                }}
              >
                <FilterPanel.Field label="Exchange">
                  <Select
                    options={exchangeOptions}
                    value={exchange || null}
                    onChange={(option) => setExchange(option)}
                    styles={customStyles}
                    placeholder="All"
                    isClearable
                  />
                </FilterPanel.Field>

                <FilterPanel.Field label="Search">
                  <input
                    type="text"
                    placeholder="User name or email"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(sanitizeInput(e.target.value))}
                  />
                </FilterPanel.Field>

                <FilterPanel.Field label="Order ID">
                  <input
                    type="text"
                    placeholder="Filter by Order ID"
                    value={filterOrderId}
                    onChange={(e) => setFilterOrderId(sanitizeInput(e.target.value))}
                  />
                </FilterPanel.Field>

                <FilterPanel.Field label="User ID">
                  <input
                    type="text"
                    placeholder="Filter by User ID"
                    value={filterUserId}
                    onChange={(e) => setFilterUserId(sanitizeInput(e.target.value))}
                  />
                </FilterPanel.Field>

                <FilterPanel.Field label="Pair">
                  <Select
                    options={pairs}
                    value={pair || null}
                    onChange={(option) => setPair(option)}
                    styles={customStyles}
                    placeholder="Any"
                    isClearable
                  />
                </FilterPanel.Field>

                <FilterPanel.Field label="Order Type">
                  <Select
                    options={tradeTypeOptions}
                    value={tradeType || null}
                    onChange={(option) => setTradeType(option)}
                    styles={customStyles}
                    placeholder="Any"
                    isClearable
                  />
                </FilterPanel.Field>

                <FilterPanel.Field label="Side">
                  <Select
                    options={sideOptions}
                    value={orderType || null}
                    onChange={(option) => setOrderType(option)}
                    styles={customStyles}
                    placeholder="Any"
                    isClearable
                  />
                </FilterPanel.Field>

                <FilterPanel.Field label="Order Status">
                  <Select
                    options={orderStatusOptions}
                    value={orderStatus || null}
                    onChange={(option) => setOrderStatus(option)}
                    styles={customStyles}
                    placeholder="Any"
                    isClearable
                  />
                </FilterPanel.Field>

                <FilterPanel.Field label="Date Range">
                  <DateRangePicker onApply={handleDateRangeChange} isClearable>
                    <input type="text" placeholder="Select date range" readOnly />
                  </DateRangePicker>
                </FilterPanel.Field>
              </FilterPanel>
            </div>
          </div>
        </div>
      </div>

      {/* Cancel confirmation modal */}
      <Modal
        open={Boolean(cancelTarget)}
        onClose={() => !cancelLoading && setCancelTarget(null)}
        closeAfterTransition
        slots={{ backdrop: backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={Boolean(cancelTarget)}>
          <Box style={styleModal}>
            <div style={{ margin: "10px 10px 6px", textAlign: "center" }}>
              <div style={{ fontSize: "16px", fontWeight: 600, marginBottom: "8px" }}>
                Cancel Order
              </div>
              <div style={{ fontSize: "13px", color: "#555", marginBottom: "8px" }}>
                Are you sure you want to cancel this order? This action cannot be undone.
              </div>
              {cancelTarget && (
                <div style={{ background: "#f8f8f8", borderRadius: "6px", padding: "8px 10px", textAlign: "left", fontSize: "13px" }}>
                  <div><strong>User:</strong> {`${cancelTarget?.user?.firstName ?? ""} ${cancelTarget?.user?.lastName ?? ""}`.trim() || "-"}</div>
                  <div><strong>Pair:</strong> {cancelTarget?.fromCoin?.symbol && cancelTarget?.toCoin?.symbol ? `${cancelTarget.fromCoin.symbol}/${cancelTarget.toCoin.symbol}` : "-"}</div>
                  <div><strong>Status:</strong> {cancelTarget?.orderId?.orderStatus || cancelTarget?.orderStatus || "-"}</div>
                  <div><strong>Type:</strong> {cancelTarget?.type || "-"} / {cancelTarget?.orderType || "-"}</div>
                </div>
              )}
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
              <button
                className="btn btn-danger"
                disabled={cancelLoading}
                onClick={handleCancelConfirm}
                style={{ marginTop: "15px", marginBottom: "10px" }}
              >
                {cancelLoading ? <Spinner size="sm" /> : "Cancel Order"}
              </button>
              <button
                className="btn btn-primary"
                disabled={cancelLoading}
                onClick={() => setCancelTarget(null)}
                style={{ marginTop: "15px", marginBottom: "10px" }}
              >
                Keep Order
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default Order;
